var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Input, ViewChild, ElementRef } from '@angular/core';
import { NavController } from 'ionic-angular';
import { CommonProvider } from '../../providers/common/common';
var MapComponent = /** @class */ (function () {
    function MapComponent(navCtrl, comProv) {
        this.navCtrl = navCtrl;
        this.comProv = comProv;
        this.marker_list = [];
        this.is_detail = false;
        this.is_top = false;
        this.marker = [];
        this.infoWindow = [];
    }
    /*ngOnChanges(changes: SimpleChanges) {
      if (changes['marker_list']) {
        this.marker_list = changes['marker_list'].currentValue;
        this.loadMap();
        this.addMarker();
      }
    }*/
    MapComponent.prototype.setList = function (lat, lng, marker_list) {
        this.lat = lat;
        this.lng = lng;
        this.marker_list = marker_list;
        this.loadMap();
        this.addMarker();
    };
    MapComponent.prototype.loadMap = function () {
        var latLng = new google.maps.LatLng(this.lat, this.lng);
        var mapOptions = {
            center: latLng,
            zoom: 15,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            scaleControl: false,
            scrollwheel: false,
            mapTypeControl: false,
            streetViewControl: false,
            navigationControl: false,
        };
        this.map = new google.maps.Map(this.mapElement.nativeElement, mapOptions);
    };
    MapComponent.prototype.addMarker = function () {
        var _this = this;
        var brand_list = this.comProv.getBrandList();
        var max_size = 40;
        brand_list.forEach(function (item) {
            if (item['image_url'] && item['aspect_ratio']) {
                if (item['aspect_ratio'] > 1) {
                    // 横長画像
                    item['image_width'] = max_size;
                    item['image_height'] = max_size / item['aspect_ratio'];
                }
                else {
                    // 縦長 or 正方形画像
                    item['image_width'] = max_size * item['aspect_ratio'];
                    item['image_height'] = max_size;
                }
            }
        });
        var _loop_1 = function (i) {
            var brand_image = null;
            var brand_data = {};
            if (this_1.marker_list[i]['brand_id']) {
                brand_data = brand_list.find(function (value) {
                    return (value['id'] == _this.marker_list[i]['brand_id']);
                });
                if (brand_data && brand_data['image_url']) {
                    brand_image = brand_data['image_url'];
                }
            }
            var markerLatLng = new google.maps.LatLng({ lat: this_1.marker_list[i]['lat'], lng: this_1.marker_list[i]['lng'] });
            var marker_set = { position: markerLatLng, map: this_1.map };
            if (brand_image) {
                marker_set['icon'] = { url: brand_image, scaledSize: new google.maps.Size(brand_data['image_width'], brand_data['image_height']) };
            }
            this_1.marker[i] = new google.maps.Marker(marker_set);
            /*let content = this.getContent(this.marker_list[i]);
            this.infoWindow[i] = new google.maps.InfoWindow({
              content: content,
            });*/
            if (this_1.is_detail) {
                //this.infoWindow[i].open(this.marker[i].getMap(), this.marker[i]);
                //this.markerEventNavi(i);
            }
            else if (this_1.is_top) {
            }
            else {
                this_1.markerEvent(i);
            }
        };
        var this_1 = this;
        for (var i = 0; i < this.marker_list.length; i++) {
            _loop_1(i);
        }
    };
    MapComponent.prototype.getContent = function (marker_data) {
        var content;
        var ios = '';
        if (this.comProv.isIos()) {
            ios = ' ios';
        }
        if (marker_data['brand'] && marker_data['brand']['image_url']) {
            var image_url = this.comProv.getThumbnailUrl(marker_data['brand']['image_url'], 500);
            content = '<div class="map_marker' + ios + '">' + '<img src="' + image_url + '" width="40px" height="40px"><div><p class="name">' + this.comProv.escapeHtml(marker_data['name']) + '</p></div></div>';
        }
        else {
            content = '<div class="map_marker' + ios + '"><div><p class="name">' + this.comProv.escapeHtml(marker_data['name']) + '</p></div></div>';
        }
        return content;
    };
    MapComponent.prototype.markerEvent = function (i) {
        var that = this;
        this.marker[i].addListener('click', function () {
            that.navCtrl.push('ShopDetailPage', {
                shop_data: that.marker_list[i],
                shop_id: that.marker_list[i]['id']
            });
        });
    };
    MapComponent.prototype.markerEventNavi = function (i) {
        var that = this;
        this.marker[i].addListener('click', function () {
            that.comProv.goNavi(that.marker_list[i]);
        });
    };
    __decorate([
        ViewChild('map'),
        __metadata("design:type", ElementRef)
    ], MapComponent.prototype, "mapElement", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Number)
    ], MapComponent.prototype, "lat", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Number)
    ], MapComponent.prototype, "lng", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], MapComponent.prototype, "marker_list", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], MapComponent.prototype, "is_detail", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], MapComponent.prototype, "is_top", void 0);
    MapComponent = __decorate([
        Component({
            selector: 'map',
            templateUrl: 'map.html'
        }),
        __metadata("design:paramtypes", [NavController,
            CommonProvider])
    ], MapComponent);
    return MapComponent;
}());
export { MapComponent };
//# sourceMappingURL=map.js.map


// WEBPACK FOOTER //
// ./src/components/map/map.ts.pre-build-optimizer.js